/**
 * App init
 */

import globalUi from './global-ui';

globalUi();
